// app/javascript/src/pages/Admin/PaymentTerms/api/usePaymentTermsList.ts
import {
  V2ListPaymentTermsForAccountApiArg,
  useV2ListPaymentTermsForAccountQuery,
} from "@generated";
import type { PaymentTerm } from "../types";

export interface UsePaymentTermsListArgs {
  page?: V2ListPaymentTermsForAccountApiArg["page"];
  filter?: V2ListPaymentTermsForAccountApiArg["filter"];
}

export interface PaymentTermsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const usePaymentTermsList = ({
  page,
  filter,
}: UsePaymentTermsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListPaymentTermsForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: PaymentTerm[] = (data?.data ?? []).map((pt) => ({
    id: String(pt.id),
    name: pt.attributes?.name ?? "",
    pricingModel: pt.attributes?.["pricing-model"] ?? "",
    rounding: pt.attributes?.rounding ?? "",
    includeExpenseInRevenue: !!pt.attributes?.["include-expense-in-revenue"],
    includeExpenseInCost: !!pt.attributes?.["include-expense-in-cost"],
    includeMaterials: !!pt.attributes?.["include-materials"],
    default: !!pt.attributes?.default,
  }));

  const pageMeta: PaymentTermsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default usePaymentTermsList;
